import react, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, getGridStringOperators, } from "@mui/x-data-grid";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import styled from "styled-components";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, InputAdornment, Select, MenuItem, InputLabel, FormControl, Paper, Autocomplete } from "@mui/material";
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, IconButton, Stack, Tab, Tabs, CircularProgress, Link } from "@mui/material";
import { Modal, Grid } from "@mui/material";
import SwapConverIcon from "../../icons/SwapConverIcon.svg"
import Tooltip from "@mui/material/Tooltip";
import { ERROR_COLOR } from "../../constants";
import DeleteIcon from '@mui/icons-material/Delete';
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import { Add, Save, SaveAlt, Search, Edit } from "@mui/icons-material";
import OrderLineItemModal from "../../components/modals/orderLineItemModal";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import AddOrderModal from "../../components/modals/addOrder";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { width } from "@mui/system";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Form } from "reactstrap";
import OrderLineItemModalAll from "../../components/modals/orderLineItemModalAll";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const TableContainer = styled.div`
// height: calc(
//   100vh - ${isMobile ? "56px - 20px - 82.23px" : "128px - 28px - 51.77px"}
// );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;
const AvatarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};
  ${isMobile &&
  `
    flex-direction: column;
  `}
`;
const LoadingContainer = styled.div`
  height: calc(100% - 49px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 56px - 20px);
  `}
`;
const GenerateReportButton = styled(Button)`
  margin-right: 10px !important;
`;
const BulkChangePinCodeButton = styled(Button)`
  margin-right: 10px !important;
`;
const PinCodeChangeButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1};
  }
`;
const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
export default function OrderManagement(props) {
  const { propType } = props || {};
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [editMode, setEditMode] = useState(false)
  const [loading, setLoading] = useState(false);
  const [newRows, setNewRows] = useState([])
  const [accessChanges, setAccessChanges] = useState([]);
  const [showOrderCheck, setShowOrderCheck] = useState(false)
  const [selectAll, setSelecetAll] = useState("0")
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [modal, setModal] = useState(false)
  const [modalAll, setModalAll] = useState(false);
  const [modalData, setModalData] = useState()
  const [modalDataAll, setModalDataAll] = useState()
  const [addModal, setAddModal] = useState(false)
  const [openModal, setOpenModal] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [accessModulesData, setAccessModulesData] = useState([]);
  const [editModalData, setEditModalData] = useState(false)
  const [rowCount, setRowCount] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20 });
  const [currentPage1, setCurrentPage1] = useState(1);
  const [paginationModel1, setPaginationModel1] = useState({ page: currentPage1, pageSize: 20 });
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [newOrderStatus, setNewOrderStatus] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);
  const [orderProcess, setOrderProcess] = useState("new");
  const [distributors, setDistributors] = useState([]);
  const [distributor, setDistributor] = useState("");
  const [stockists, setStockists] = useState([]);
  const [stockist, setStockist] = useState("");
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [openDialog, setOpenDialog] = useState(false);
  const [rejectData, setRejectData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [reason, setReason] = useState("");
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteOrderData, setDeleteOrderData] = useState(null);
  const [deleteRemark, setDeleteRemark] = useState("");
  const [search, setSearch] = useState("")
  const [LocalStoredData, setLocalStoredData] = useState(JSON.parse(localStorage.getItem("storedUserData")))
  const [selectedSeries, setSelectedSeries] = useState("")
  const [series, setSeries] = useState([])
  const [selectedRole, setSelectedRole] = useState("")
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [startDeliveryDate, setStartDeliveryDate] = useState("")
  const [endDeliveryDate, setEndDeliveryDate] = useState("")
  const [schoolOrderModalData, setSchoolOrderModalData] = useState([])
  const [schoolOrderOpenViewModal, setSchoolOrderOpenViewModal] = useState(false)
  const [hasSearched, setHasSearched] = useState(false)
  const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
  const [filteredDate, setFilteredData] = useState({});
  const [convertModalOpen, setConvertModalOpen] = useState(false);
  const [convertData, setConvertData] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [chooseAttachmentModal, setChooseAttachmentModal] = useState(false);
  useEffect(() => {
    fetchSessions();
    if (propType === "Specimen") {
    } else {
      fetchDistributor();
      fetchStockist();
    }
  }, []);

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = await window.Platform.database.getAllSessions();
      if (response?.status) {
        const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
        setFilteredData(filterdData1[0])
      }
      else {
        window.NotificationUtils.showError("Something Went Wrong in session")
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      window.NotificationUtils.showError("Failed to load sessions");
    } finally {
      setLoading(false);
    }
  };

  async function getUsers(role, id) {
    setLoading(true);
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results.data)
        setRms(results.data1)
      }
      if (role == 'asm') {
        setRms(results.data)
      }
      setLoading(false);
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers.filter((ele) => ele.role == 'se'))
        setAsms(allUsers.filter((ele) => ele.role == 'asm'))
      }

      if (role == 'asm') {
        setRm("")
        setRms(allUsers.filter((ele) => ele.role == 'se'))
      }
      setLoading(false);
    }

  }
  const handleTabChange = async (value) => {
    setStartDate(null)
    setEndDate(null)
    setSelectedTab(value);
  }
  const fetchAccessModules = async () => {
    try {
      setLoading(true);
      let results
      if (propType === "Specimen") {
        let data = {
          pageNumber: paginationModel.page,
          recordPerPage: paginationModel.pageSize,
          userId: userData?.id,
          moduleId: "y3c1z87xwS"
        }
        results = await window.Platform.database.fetchAccessModules(data);
        if (results?.status) {
          window.NotificationUtils.showError(results?.message || "Something went wrong");
          setLoading(false);
          return;
        }
        else {
          const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
          setAccessModulesData(jsonArrayWithId);
        }
      }
      else {
        let data = {
          pageNumber: paginationModel.page,
          recordPerPage: paginationModel.pageSize,
          userId: userData?.id,
          moduleId: "zUcuserSGr"
        }
        results = await window.Platform.database.fetchAccessModules(data);
        if (results?.status) {
          window.NotificationUtils.showError(results?.message || "Something went wrong");
          setLoading(false);
          return;
        }
        else {
          const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
          setAccessModulesData(jsonArrayWithId);
        }
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (hasSearched) {
      if (selectedTab === 0) {
        fetchOrder();
      }
      else {
        fetchOrder1()
      }
    }
  }, [newOrderStatus, orderProcess, paginationModel.page, paginationModel1.page, paginationModel.pageSize, paginationModel1.pageSize]);

  useEffect(() => {
    setShowOrderCheck(false);
    setSelecetAll("0");
    setSelectedOrders([]);
  }, [newOrderStatus, paginationModel.page, paginationModel1.page, paginationModel.pageSize, paginationModel1.pageSize, selectedTab]);

  useEffect(() => {
    fetchAccessModules();
    getSeries()
    if (userData?.role.includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, []);

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results.data)
      setRsms(results.data.filter((ele) => ele.role == 'rsm'))
      setRms(results.data.filter((ele) => ele.role == 'se'))
      setAsms(results.data.filter((ele) => ele.role == 'asm'))
      setLoading(false);
    }
  }

  const getSeries = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getSeriesCategory();
      if (results?.message == "Session Expired Please LogIn Again") {
        window.NotificationUtils.showError(results.message);
        setLoading(false);
        return;
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj) => ({
          ...obj,
          dbId: obj.id
        }));
        setSeries(jsonArrayWithId);
        setLoading(false);
      }

    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  };

  const formatDateTime = (inputDateString) => {
    const inputDate = new Date(inputDateString);
    if (isNaN(inputDate.getTime())) {
      return 'Invalid Date';
    }
    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');
    const formattedDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateString;
  }

  useEffect(() => {
    setRsm("");
    setAsm("");
    setRm("");
    setSearch("");
    setFromDate("");
    setToDate("");
    setOrderProcess("new");
    setNewOrderStatus(0);
    setSelectedSeries("");
    setHasSearched(false);
    setPaginationModel({ page: 0, pageSize: 20 });
    setAccessChanges([]);
  }, [selectedTab])

  const fetchOrder = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        filter: search,
        fromDate: fromDate != '' ? fromDate : filteredDate?.startDate,
        toDate: toDate != '' ? toDate : filteredDate?.endDate,
        series: selectedSeries,
        startDeliveryDate: startDeliveryDate,
        endDeliveryDate: endDeliveryDate,
        distributorId: distributor,
        stockistId: stockist,
        asm: userData?.role === 'asm' ? userData?.id : asm,
        rsm: userData?.role === 'rsm' ? userData?.id : rsm,
        ownerId: rm,
        recordPerPage: paginationModel.pageSize,
        approvalStatus: newOrderStatus,
        order_type: propType,
        orderProcess: orderProcess,
        orderStatus: 0,
      }
      let results = await window.Platform.database.fetchOrder(data);
      if(results?.status){
      setLoading(false)
      window.NotificationUtils.showError("Soemthing Went Wrong");
      }
      else{
        setNewRows(results?.data)
        let jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setRowCount(results?.data1)
        setAccessChanges(jsonArrayWithId);
      setLoading(false)
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
  }

  const fetchDistributor = async () => {
    setLoading(true);
    const body = { ownerId: "" };
    try {
      const response = await window.Platform.database.getAllDistri(body);
      if (response && response.data) {
        const data = response.data;
        setDistributors(data)
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error("Failed to load distributors");
      }
    } catch (error) {
      console.error("Error fetching distributors:", error);
      setLoading(false);
    }
  };

  const fetchStockist = async (distru) => {
    const body = { pageNumber: 0 };
    try {
      const response = await window.Platform.database.getStockistAll(body);
      if (response && response.data) {
        setStockists(response.data);
      } else {
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.error("Error fetching stockists:", error);
    }
  };

  const approveRejectOrder = async (val) => {
    val["ownerId"] = userData.id
    try {
      setLoading(true)
      if (userData?.role == 'asm') {
        const results = await window.Platform.database.updateAsmApproval({ orderId: val?.id })
      }
      else {
        const results = await window.Platform.database.approverejectOrder(val)
      }
      window.NotificationUtils.showSuccess("Order Update Success")
      setLoading(false)
      if (selectedTab === 0) {
        fetchOrder()
      } else {
        fetchOrder1()
      }
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)
    }
  }
  const downloadFile = async (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file.originalName || file.fileName || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const handleReject = (data) => {
    setRejectData(data);
    setOpenDialog(true);
  };

  const handleConfirmReject = () => {
    if (reason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to reject the order.")
      return;
    }
    approveRejectOrder({ ...rejectData, approvalStatus: "2", reason });
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
  };

  const handleCloseImageView = () => {
    setSelectedImage(null);
    setSelectedPdf(null);
  };
  const handleImageClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
    setSelectedImage(file);
    setSelectedPdf(null);
  };

  const handlePdfClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
    setLoading(true);
    setSelectedPdf(file);
    setSelectedImage(null);
  };

  useEffect(() => {
    if (!selectedImage && !selectedPdf) {
      setLoading(false);
    }
  }, [selectedImage, selectedPdf]);



  const handleOpenModal = (attachmentData) => {
    if (attachmentData !== "N/A") {
      try {
        const parsedData = JSON.parse(attachmentData);
        setAttachments(parsedData);
      } catch (error) {
        console.log("Invalid JSON format:", error);
        setAttachments([]);
      }
    } else {
      setAttachments([]);
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const fetchOrder1 = async (data) => {
    try {
      setLoading(true);
      let data1 = {
        pageNumber: paginationModel.page,
        orderStatus: 1,
        filter: search,
        series: selectedSeries,
        fromDate: fromDate != '' ? fromDate : filteredDate?.startDate,
        toDate: toDate != '' ? toDate : filteredDate?.endDate,
        ownerId: rm,
        asm: userData?.role === 'asm' ? userData?.id : asm,
        rsm: userData?.role === 'rsm' ? userData?.id : rsm,
        recordPerPage: paginationModel1.pageSize,
        approvalStatus: newOrderStatus,
        order_type: propType,
        orderProcess: orderProcess
      };
      let results;
      if (data?.user?.role.toLowerCase().includes('admin')) {
        results = await window.Platform.database.fetchOrder(data1, selectedRole, selectedSeries, search);
      }
      else {
        results = await window.Platform.database.fetchOrder(data1);
      }
      let jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setRowCount(results.data1)
      setAccessChanges(jsonArrayWithId);
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }

  const handleDeleteOrder = async (data, tab) => {

    const isConfirmed = window.confirm("Are you sure you want to delete this item?");

    if (!isConfirmed) {
      return;
    }

    try {
      setLoading(true);
      let results = await window.Platform.database.deleteOrder({ id: data });
      tab == 0 ? fetchOrder() : fetchOrder1()
      setLoading(false);
      window.NotificationUtils.showSuccess("Deleted successfully!");
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // const handleConvertToOrder = async (data)=> {
  //   const isConfirmed = window.confirm("You are converting this entry as an Order. Make sure it is not by mistake and you intend to convert this Booking Consent to Order. ");

  //   if (!isConfirmed) {
  //     return;
  //   }
  //   try {
  //     setLoading(true);
  //     let results = await window.Platform.database.convertToOrder({ orderId: data.orderId });
  //     selectedTab == 0 ? fetchOrder() : fetchOrder1()
  //     setLoading(false);
  //     window.NotificationUtils.showSuccess("Converted successfully !!");
  //   } catch (error) {
  //     window.NotificationUtils.showError("Error converting order");
  //     console.error(error);
  //     setLoading(false);
  //   }
  // }
   const handleConvertToOrder = (data) => {
    setConvertData(data);
    setSelectedImages([]);
    setChooseAttachmentModal(true);
  }

const handleConfirmConvert = async () => {
  if (selectedImages.length === 0) {
    window.NotificationUtils.showError("Please select at least one image.");
    return;
  }

  try {
    setLoading(true);

    const formData = new FormData();
    formData.append("orderId", convertData.orderId);

    selectedImages.forEach((file) => {
      formData.append("files", file);
    });

    const response = await fetch(
      `${window.Platform.database.funcForBaseURL()}/order/convertToOrder`,
      {
        method: "POST",
        body: formData
      }
    );

    const result = await response.json();

    if (result.status) {
      window.NotificationUtils.showSuccess("Converted successfully !!");
      selectedTab == 0 ? fetchOrder() : fetchOrder1();
    } else {
      window.NotificationUtils.showError(result.message || "Something went wrong");
    }

  } catch (error) {
    console.error(error);
    window.NotificationUtils.showError("Error converting order");
  } finally {
    setLoading(false);
    setConvertModalOpen(false);
    setSelectedImages([]);
    setConvertData(null);
  }
};

  const handleConvertWithoutAttachment = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.convertToOrderForWeb({ orderId: convertData.orderId });
      if (results?.status) {
        window.NotificationUtils.showSuccess("Converted successfully !!");
        selectedTab == 0 ? fetchOrder() : fetchOrder1();
      } else {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error converting order");
    } finally {
      setLoading(false);
      setChooseAttachmentModal(false);
      setConvertData(null);
    }
  };

  const handleDownloadSingleZipImage = async (data) => {
    try {
      if (!data?.attachment) {
        alert("No attachment found");
        return;
      }
      const attachments = JSON.parse(data.attachment);
      if (!attachments.length) {
        alert("No files available");
        return;
      }
      const zip = new JSZip();
      const folderName = data.so_id?.replace(/\//g, "_") || "attachments";
      const folder = zip.folder(folderName);
      for (const file of attachments) {
        const fileUrl = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error("File fetch failed");
        const buffer = await response.arrayBuffer();
        folder.file(file.originalName || file.fileName, buffer);
      }
      const zipBlob = await zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
      });
      saveAs(zipBlob, `${folderName}.zip`);
    } catch (error) {
      console.error("ZIP download error:", error);
      alert("Failed to download attachment");
    }
  };

  const handleDownloadAllImagesZip = async (rows) => {
    setLoading(true);
    try {
      if (!rows?.length) {
        alert("No data available");
        return;
      }
      const zip = new JSZip();
      const folder = zip.folder("ALL_ATTACHMENTS");
      for (const row of rows) {
        if (!row.attachment) continue;
        let attachments = [];
        try {
          attachments = JSON.parse(row.attachment);
        } catch {
          continue;
        }
        const safeSoId = row.so_id?.replace(/\//g, "_") || "UNKNOWN_SO";
        let index = 1;
        for (const file of attachments) {
          const fileUrl = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
          const response = await fetch(fileUrl);
          if (!response.ok) continue;
          const buffer = await response.arrayBuffer();
          const ext = file.originalName?.split(".").pop() || "jpg";
          const zipFileName = `${safeSoId}_${index}.${ext}`;
          folder.file(zipFileName, buffer);
          index++;
        }
      }
      const zipBlob = await zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
      });
      saveAs(zipBlob, `ALL_SO_ATTACHMENTS.zip`);
    } catch (error) {
      console.error("Bulk ZIP error:", error);
      alert("Failed to download ZIP");
    }
    finally {
      setLoading(false);
    }
  };

  const handleOpenSchoolOrderViewModal = (id) => {
    setSchoolOrderModalData(id)
    setSchoolOrderOpenViewModal(true);
  }

  const handleCloseSchoolOrderViewModal = () => {
    setSchoolOrderOpenViewModal(false);
    setSchoolOrderModalData([]);
  }

  const downloadSingleOrder = async (data) => {
    setLoading(true);
    try {
      const payload = {
        orderId: data?.orderId,
        orderProcess: data.orderProcess
      };
      let result = await window.Platform.database.exportData("/order/downloadSingleOrder", payload)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `single-order-${data.so_id}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };

  const downloadSingleOrderSpecimen = async (data) => {
    setLoading(true);
    try {
      const payload = {
        orderId: data?.orderId,
        orderProcess: data.orderProcess
      };
      let result = await window.Platform.database.exportData("/order/downloadSingleOrderSpecimen", payload)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `single-order-${data.so_id}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };

  const handleCheckboxChange = (e, orderId) => {
    const isChecked = e.target.checked;
    if (e.target.checked) {
      setSelectedOrders((prev) => [...prev, orderId]);
    } else {
      setSelectedOrders((prev) => prev.filter((id) => id !== orderId));
    }
    if (!isChecked) {
      setSelecetAll("0");
    }
  };

  const approveAllOrders = async () => {
    const isConfirmed = window.confirm(" Are you sure you want to Approve all the selected orders ? ");
    if (!isConfirmed) return;
    try {
      setLoading(true)
      const payload = {
        orderIds: selectedOrders
      }
      const results = await window.Platform.database.batchApproveOrders(payload)
      if (results?.status) {
        window.NotificationUtils.showSuccess(results?.message || "Orders Approved Successfully")
        fetchOrder();
        setShowOrderCheck(false);
        setSelecetAll("0");
        setSelectedOrders([]);
      }
      setLoading(false)
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)
    }
  }

  const rejectAllOrders = async () => {
    const isConfirmed = window.confirm(" Are you sure you want to reject all the selected orders ? ");
    if (!isConfirmed) return;
    try {
      setLoading(true)
      const payload = {
        orderIds: selectedOrders
      }
      const results = await window.Platform.database.batchRejectOrders(payload)
      if (results?.status) {
        window.NotificationUtils.showSuccess(results?.message || "Orders Rejected Successfully")
        fetchOrder();
        setShowOrderCheck(false);
        setSelecetAll("0");
        setSelectedOrders([]);
      }
      setLoading(false)
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)
    }
  }

  const handleDelete = async (data) => {
    setDeleteOrderData(data);
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    if (deleteRemark.trim() === "") {
      window.NotificationUtils.showError("Remark is required to delete the order.")
      return;
    }
    performDelete();
  };

  const performDelete = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.deleteOrder({ id: deleteOrderData, deleteRemark: deleteRemark });
      if (results?.status) {
        window.NotificationUtils.showSuccess(results?.message || "Order deleted successfully!");
        if (selectedTab == 0) {
          fetchOrder();
        }
        else {
          fetchOrder1();
        }
        setLoading(false);
      }
      else {
        window.NotificationUtils.showSuccess("Status False Delete Order");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
    setOpenDeleteDialog(false);
    setDeleteRemark("");
    setDeleteOrderData(null);
  };

  const hasAttachment = (() => {
    try {
      const parsed = JSON.parse(schoolOrderModalData?.attachment || "[]");
      return Array.isArray(parsed) && parsed.length > 0;
    } catch (e) {
      return false;
    }
  })();

  const getEmployeeColumns = () => {
    const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
    let result = [
      showOrderCheck && {
        field: "Swap",
        headerName: (
          <>
            <input
              type="checkbox"
              onChange={handleSelectAll}
              checked={selectAll == "1" ? true : false}
              width={"30"}
            />
          </>
        ),
        width: 30,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <input
            type="checkbox"
            checked={selectedOrders.includes(params.row.orderId)}
            onChange={(e) => handleCheckboxChange(e, params.row.orderId)}
            style={{ borderRadius: "4px", border: "1px solid #ccc", }}
          />
        ),
      },
      {
        field: "SONo",
        headerName: "SO No.",
        sortable: false,
        width: 180,

        editable: false,
        filterOperators: stringOperators
        ,
        renderCell: (params) => {
          let name = params.row?.so_id || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "schoolName",
        headerName: "Party Name",
        width: newOrderStatus == 1 ? 380 : newOrderStatus == 2 ? 280 : newOrderStatus == 3 ? 380 : newOrderStatus == 4 ? 380 : newOrderStatus == 6 ? 283 : 350,
        filterOperators: stringOperators
        ,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.schoolName ? params.row?.schoolName : params.row?.DistributorName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      propType != "Specimen" && {
        field: "totalAmount",
        headerName: "Total Amount",
        width: 160,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          const rawAmount = +params.row?.totalAmount;
          const rawAmount11 = +params.row?.tentativeAmount;
          let name;
          if (orderProcess == "upload") {
            name = rawAmount11;
          }
          else {
            if (isNaN(rawAmount)) {
              name = "N/A";
            } else {
              const formattedAmount = rawAmount.toFixed(2);
              name = Number(formattedAmount).toLocaleString('en-IN');
            }
          }
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "createdAtDateEx",
        headerName: "Created Date",
        width: 160,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          let dateStr = params.row.createdAt;
          let name = "N/A";
          if (dateStr) {
            const dateObj = new Date(dateStr);
            name = dateObj.toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
          }
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Order Mode",
        headerName: "Order Mode",
        width: 150,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.orderMode == "direct" ? "Direct Order" : "RM Created" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Booked By1",
        headerName: "Booked By",
        width: 200,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      propType != "Specimen" && {
        field: "approvedBy",
        headerName: `${newOrderStatus == 1 ? "Approved By" : newOrderStatus == 2 ? "Rejected By" : "Action Taken By"}`,
        width: newOrderStatus == 2 ? 150 : newOrderStatus == 6 ? 160 : 200,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.approvedBy || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      newOrderStatus && newOrderStatus == 2 && {
        field: "Reject Reason",
        headerName: "Reject Reason",
        width: 220,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.reason || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "View",
        headerName: "Order Details",
        width: 120,
        editable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenSchoolOrderViewModal(params.row)}
                    sx={{ minWidth: "70px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={schoolOrderOpenViewModal} onClose={handleCloseSchoolOrderViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" mb={1} style={{ textAlign: "center" }}>
                    Order Details
                  </Typography>
                  <hr style={{ width: "100%", color: "#000", borderTop: "1px solid black" }} />
                  <div>
                    <div className="row mb-3">
                      {selectedTab == 0 ?
                        <div className="col-12">
                          <b> Party Name : </b>{schoolOrderModalData && schoolOrderModalData?.schoolName || "N/A"}
                        </div>
                        :
                        <div className="col-12">
                          <b> Party Name : </b>{schoolOrderModalData && schoolOrderModalData?.DistributorName || "N/A"}
                        </div>
                      }
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Booked By : </b> {schoolOrderModalData && (schoolOrderModalData?.name + " - " + schoolOrderModalData?.username )|| "N/A"}
                      </div>
                      {propType !== "Specimen" && (
                        <>
                          {schoolOrderModalData?.orderProcess === "new" ? (
                            <div className="col-md-6">
                              <b>Total Amount :</b>{" "}
                              {schoolOrderModalData?.totalAmount || "N/A"}
                            </div>
                          ) : (
                            <div className="col-md-6">
                              <b>Tentative Amount :</b>{" "}
                              {schoolOrderModalData?.tentativeAmount || "N/A"}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Email Id :</b> {schoolOrderModalData && schoolOrderModalData?.emailId || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Mobile Number :</b> {schoolOrderModalData && schoolOrderModalData?.mobile || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      {propType != "Specimen" && <div className="col-md-6">
                        <b>Transporter Name :</b> {schoolOrderModalData && schoolOrderModalData?.transporter_name || "N/A"}
                      </div>}
                      <div className="col-md-6">
                        <b>OTP Consent :</b> {schoolOrderModalData && schoolOrderModalData?.otpConsent || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>Created At:</b>{" "}
                        {schoolOrderModalData?.createdAt
                          ? `${new Date(schoolOrderModalData.createdAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })}, ${new Date(schoolOrderModalData.createdAt).toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}`
                          : "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Remark :</b> {schoolOrderModalData && schoolOrderModalData?.remark || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-12">
                        <b> Order Remark : </b> {schoolOrderModalData && schoolOrderModalData?.order_remark || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-12">
                        <b>Attachment </b>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleOpenModal(schoolOrderModalData?.attachment)}
                          disabled={schoolOrderModalData && !hasAttachment}
                          sx={{ minWidth: "150px" }}
                        >
                          {hasAttachment ? "View Attachments" : "No Data Found"}
                        </Button>
                        <Modal open={openModal} onClose={handleCloseModal}>
                          <Box
                            sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "80%", maxWidth: 800, bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, maxHeight: "80%", overflowY: "auto", }} >
                            <Typography variant="h6" component="h2" mb={2}>
                              Attachment Details
                            </Typography>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                              {attachments && attachments?.map((file, index) => {
                                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(file.fileName);
                                const isPDF = /\.pdf$/i.test(file.fileName);

                                return (
                                  <div key={index} style={{ cursor: "pointer" }}>
                                    {isImage && (
                                      <img
                                        //  src={`https://mittsureone.com:3001/file/${file.fileName}`}
                                        src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                        alt={file.originalName}
                                        style={{ width: "150px", height: "auto", margin: "10px", borderRadius: "8px", boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)", }}
                                        onClick={() => handleImageClick(file)}
                                      />
                                    )}
                                    {isImage && (
                                      <div style={{ textAlign: 'center' }}>
                                        {/* <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}> */}
                                        <div>
                                          <a
                                            href={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={() => handleImageClick(file)}
                                          >
                                            {file.originalName}
                                          </a>
                                        </div>
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            downloadFile(file);
                                          }}
                                        >
                                          Download
                                        </Button>
                                      </div>
                                    )}
                                    {isPDF && (
                                      <div style={{ width: "150px", height: "200px", margin: "10px", border: "1px solid #ddd", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f5f5f5", }}
                                        onClick={() => handlePdfClick(file)}
                                      >
                                        <Typography variant="body2" color="textSecondary" textAlign="center"> {file.originalName} </Typography>
                                      </div>
                                    )}
                                    {isPDF && (
                                      <div style={{ textAlign: 'center' }}>
                                        <div>
                                          <a
                                            href={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={() => handlePdfClick(file)}
                                          >
                                            {file.originalName}
                                          </a>
                                        </div>
                                        <div>
                                          <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              downloadFile(file);
                                            }}
                                          >
                                            Download
                                          </Button>
                                        </div>
                                      </div>
                                    )}
                                    {!isImage && !isPDF && (
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <a
                                          href={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          onClick={() => handleImageClick(file)}
                                        >
                                          {file.originalName}
                                        </a>
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            downloadFile(file);
                                          }}
                                        >
                                          Download
                                        </Button>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                            <Box mt={2} display="flex" justifyContent="flex-end">
                              <Button onClick={handleCloseModal} variant="contained" color="primary">
                                Close
                              </Button>
                            </Box>
                          </Box>
                        </Modal>
                      </div>
                    </div>
                    <div className="row mb-3">
                              <div className="col-md-6">
                        <b> Distributor Type : </b> {schoolOrderModalData && schoolOrderModalData?.distributorType == "onboarded" ? "Onboarded Distributor" : schoolOrderModalData?.distributorType == "schoolPreferred" ? "School Preferred Distributor" : "N/A" || "N/A"}

                              </div>
                               <div className="col-md-6">
                        <b> Distributor : </b> {schoolOrderModalData && (schoolOrderModalData?.distributorNameforSchool + " - " + schoolOrderModalData?.distributorId) || "N/A"}
                      </div>
                    </div>
                    <span style={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                      Party Address:
                    </span>
                    <div className="row mb-2 mt-3">
                      <div className="col-12">
                        <b>Address:</b>{" "}
                        {(() => {
                          const addresses = [
                            schoolOrderModalData?.sAddress,
                            schoolOrderModalData?.dAddress,
                            schoolOrderModalData?.stAddress
                          ];
                          for (const addr of addresses) {
                            if (addr) {
                              try {
                                const parsedAddr = JSON.parse(addr);
                                if (parsedAddr?.addressLine1) {
                                  return parsedAddr.addressLine1;
                                }
                              } catch (error) {
                                console.error("Invalid JSON in address:", addr);
                              }
                            }
                          }
                          return "N/A";
                        })()}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <b>District:</b>{" "}
                        {(() => {
                          const addresses = [
                            schoolOrderModalData?.sAddress,
                            schoolOrderModalData?.dAddress,
                            schoolOrderModalData?.stAddress
                          ];
                          for (const addr of addresses) {
                            if (addr) {
                              try {
                                const parsedAddr = JSON.parse(addr);
                                if (parsedAddr?.district) {
                                  return parsedAddr.district;
                                }
                              } catch (error) {
                                console.error("Invalid JSON in address:", addr);
                              }
                            }
                          }
                          return "N/A";
                        })()}
                      </div>
                      <div className="col-md-4">
                        <b>State:</b>{" "}
                        {(() => {
                          const addresses = [
                            schoolOrderModalData?.sAddress,
                            schoolOrderModalData?.dAddress,
                            schoolOrderModalData?.stAddress
                          ];

                          for (const addr of addresses) {
                            if (addr) {
                              try {
                                const parsedAddr = JSON.parse(addr);
                                if (parsedAddr?.state) {
                                  return parsedAddr.state;
                                }
                              } catch (error) {
                                console.error("Invalid JSON in address:", addr);
                              }
                            }
                          }
                          return "N/A";
                        })()}
                      </div>

                      <div className="col-md-4">
                        <b>Pincode:</b>{" "}
                        {(() => {
                          const addresses = [
                            schoolOrderModalData?.sAddress,
                            schoolOrderModalData?.dAddress,
                            schoolOrderModalData?.stAddress
                          ];
                          for (const addr of addresses) {
                            if (addr) {
                              try {
                                const parsedAddr = JSON.parse(addr);
                                if (parsedAddr?.pincode) {
                                  return parsedAddr.pincode;
                                }
                              } catch (error) {
                                console.error("Invalid JSON in address:", addr);
                              }
                            }
                          }
                          return "N/A";
                        })()}
                      </div>
                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseSchoolOrderViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
      newOrderStatus && newOrderStatus == 6 && {
        field: "discard",
        headerName: "Discard",
        width: 110,
        editable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button variant="contained" size="small" onClick={() => handleDeleteOrder(params.row.orderId, selectedTab)} sx={{ minWidth: "80px" }} >
                    {"Discard"}
                  </Button>
                </span>
              </Tooltip>
            </>
          );
        },
      },
      {
        field: "Approve Order",
        headerName: "Actions",
        width: propType === "Specimen" ? 200 : (newOrderStatus == 0 ? 250 : newOrderStatus == 1 ? 150 : newOrderStatus == 2 ? 150 : newOrderStatus == 3 ? 150 : newOrderStatus == 4 ? 150 : newOrderStatus == 5 ? 250 : newOrderStatus == 6 ? 250 : newOrderStatus == 7 ? 120 : 250),
        filterable: false,
        headerAlign: 'center',
        sortable: false,
        renderCell: (params) => {
          let value = params.row?.orderId
          let ownerId = params.row?.ownerId
          let allValues = params.row
          const showApproveReject = (orderProcess === "new" || (orderProcess != "upload" && params.row.ItemOrder != 0));
          const showDownloadIcon = ((orderProcess === "new") || (orderProcess === "upload" && params.row?.updateRemark && params.row.updateRemark.trim() !== "" || params.row.updateRemark != null));
          return (
            <Stack direction={"row"} spacing={0}>
              {orderProcess != "upload" && <Tooltip title="Click to view order items"><IconButton variant="extended" color="primary" onClick={(e) => {
                e.stopPropagation();
                fetchOrderLineItem(value);
              }} >
                <RemoveRedEyeIcon />
              </IconButton></Tooltip>}
              {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <Tooltip title="Download Single Order">
                <IconButton variant="extended" color="primary" onClick={(e) => {
                  e.stopPropagation();
                  propType == "Specimen" ? downloadSingleOrderSpecimen(allValues) : downloadSingleOrder(allValues);
                }} >
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>}
              {userData?.role.includes('admin') && (propType === "Specimen" ? (newOrderStatus == 0 || newOrderStatus == 4 || newOrderStatus == 6) : (newOrderStatus == 0 || newOrderStatus == 6)) && accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no" &&
                <Tooltip title="Click to edit order"><IconButton variant="extended"
                  onClick={(e) => {

                    editData(allValues);
                  }} >
                  <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                </IconButton></Tooltip>}
              {newOrderStatus != 7 && showApproveReject && propType != "Specimen" && (accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" && (userData.role === 'asm' ? (
                params.row.asmApproval !== 1 &&
                newOrderStatus !== 1 &&
                newOrderStatus !== 2 &&
                newOrderStatus !== 3 &&
                newOrderStatus !== 4 && (
                  <Tooltip title="Click to approve order">
                    <IconButton
                      disabled={params.row?.approvalStatus === 1 || params.row?.approvalStatus === 2}
                      variant="extended"
                      sx={{ color: "#008000" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        approveRejectOrder({ id: value, approvalStatus: "1", ownerId });
                      }}
                    >
                      <ThumbUpIcon />
                    </IconButton>
                  </Tooltip>
                )
              ) : (
                newOrderStatus !== 1 &&
                newOrderStatus !== 2 &&
                newOrderStatus !== 3 &&
                newOrderStatus !== 4 && (
                  <Tooltip title="Click to approve order">
                    <IconButton
                      disabled={params.row?.approvalStatus === 1 || params.row?.approvalStatus === 2}
                      variant="extended"
                      sx={{ color: "#008000" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        approveRejectOrder({ id: value, approvalStatus: "1", ownerId });
                      }}
                    >
                      <ThumbUpIcon />
                    </IconButton>
                  </Tooltip>
                )
              )))}
              {newOrderStatus != 7 && showApproveReject && propType != "Specimen" && (accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" && (userData.role === 'asm' ? (
                params.row.asmApproval !== 1 &&
                newOrderStatus !== 1 &&
                newOrderStatus !== 2 &&
                newOrderStatus !== 3 &&
                newOrderStatus !== 4 && (
                  <Tooltip title="Click to reject order">
                    <IconButton
                      disabled={params.row?.approvalStatus === 1 || params.row?.approvalStatus === 2}
                      variant="extended"
                      sx={{ color: "red" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReject({ id: value, ownerId });
                      }}
                    >
                      <ThumbDownIcon />
                    </IconButton>
                  </Tooltip>
                )
              ) : (
                newOrderStatus !== 1 &&
                newOrderStatus !== 2 &&
                newOrderStatus !== 3 &&
                newOrderStatus !== 4 && (
                  <Tooltip title="Click to reject order">
                    <IconButton
                      disabled={params.row?.approvalStatus === 1 || params.row?.approvalStatus === 2}
                      variant="extended"
                      sx={{ color: "red" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReject({ id: value, ownerId });
                      }}
                    >
                      <ThumbDownIcon />
                    </IconButton>
                  </Tooltip>
                )
              )))}

              {newOrderStatus != 7 && (userData?.master == 1 && userData?.role == "super admin") && <Tooltip title={"Delete"}>
                <IconButton onClick={() => handleDelete(params.row.orderId)} disabled={params?.row?.is_deleted == 1}>
                  <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "400" }} />
                </IconButton>
              </Tooltip>}
            </Stack>
          )
        },
      },
      {
        field: "DownloadAttachment",
        headerName: "Download Attachment",
        width: 200,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button startIcon={<FileDownloadIcon />} variant="contained" size="small" onClick={() => handleDownloadSingleZipImage(params.row)} sx={{ minWidth: "70px" }} >
                    Attachment
                  </Button>
                </span>
              </Tooltip>
            </>
          );
        },
      },
      // propType === "Sales" && orderProcess == "new" && newOrderStatus == 1 && {
      //   field: "converToOrder",
      //   headerName: "Convert To Order",
      //   width: 180,
      //   sortable: false,
      //   renderCell: (params) => {
      //     return (
      //       <>
      //         <Tooltip>
      //           <span>
      //            {params.row.convertToOrder == 0 ? <Button startIcon={<img src={SwapConverIcon} alt="icon" height={"21"} width={"21"} />} variant="contained" size="small" onClick={() => handleConvertToOrder(params.row)} sx={{ minWidth: "110px" }} >
      //               Convert
      //             </Button>
      //             :
      //             //  <span startIcon={<img alt="icon" height={"21"} width={"21"} />} variant="contained" size="small" color="success" sx={{ minWidth: "90px" }} >
      //             //   Converted
      //             // </span>
      //              params.row.convertToOrder == 1 ? <div
      //                 style={{
      //                   display: "inline-flex",
      //                   alignItems: "center",
      //                   gap: "8px",
      //                   backgroundColor: params.row?.convertToOrder === 0 ? "#ffffffff" : "#ffffffff",
      //                   color: "#000000ff",
      //                   padding: "6px 6px",
      //                   fontSize: "14px",
      //                   fontWeight: "500",
      //                   boxShadow: "0 2px 6px rgba(38, 35, 35, 0.1)",
      //                 }}
      //               >
      //                 <svg
      //                   xmlns="http://www.w3.org/2000/svg"
      //                   height="20px"
      //                   viewBox="0 0 24 24"
      //                   width="20px"
      //                   fill={params.row?.convertToOrder == 1 ? "#00ff26ff" : "#2bff00ff"}
      //                 >
      //                   <path d="M0 0h24v24H0z" fill="none" />
      //                   <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
      //                 </svg>
      //                 Converted
      //               </div>
      //             :<></>
      //             }
      //           </span>
      //         </Tooltip>
      //       </>
      //     );
      //   },
      // },

    ].filter(Boolean);
    return result
  }

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,  // Use 12-hour clock
    };

    const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);
    return formattedDate;
  };

  const fetchOrderLineItem = async (val) => {
    try {
      setLoading(true)
      setModalData()
      let sentData = { id: val }
      let results = await window.Platform.database.fetchOrderLineItem(sentData);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setModalData({ data: jsonArrayWithId, id: val })
      setModal(true)
      setLoading(false)
    }
    catch (error) {
      console.log(error)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)
    }
  }

  const editData = (data) => {
    setEditModalData(data)
    setEditMode(true)
    setAddModal(true)
  }

  function CustomToolbar() {
    return (
      <>
        <GridToolbarContainer>
          <Button
            onClick={() => { setHasSearched(true); setNewOrderStatus(5) }}
            style={{ backgroundColor: newOrderStatus === 5 ? "#8787f470" : "white", color: newOrderStatus === 5 ? "#000000" : "black", }} >
            All
          </Button>
          {propType != "Specimen" && <>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(0) }}
              style={{
                backgroundColor: newOrderStatus === 0 ? "#fe9f13" : "white",
                color: newOrderStatus === 0 ? "white" : "black",
              }}
            >
              Pending
            </Button>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(1) }}
              style={{
                backgroundColor: newOrderStatus === 1 ? "green" : "white",
                color: newOrderStatus === 1 ? "white" : "black",
              }}
            >
              Approved
            </Button>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(2) }}
              style={{
                backgroundColor: newOrderStatus === 2 ? "red" : "white",
                color: newOrderStatus === 2 ? "white" : "black",
              }}
            >
              Rejected
            </Button>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(3) }}
              style={{
                backgroundColor: newOrderStatus === 3 ? "#2196f3" : "white",
                color: newOrderStatus === 3 ? "white" : "black",
              }}
            >
              Shipped
            </Button>
          </>}
          <Button
            onClick={() => { setHasSearched(true); setNewOrderStatus(4) }}
            style={{
              backgroundColor: newOrderStatus === 4 ? "#9c27b0" : "white",
              color: newOrderStatus === 4 ? "white" : "black",
            }}
          >
            Delivered
          </Button>
          <Button
            onClick={() => { setHasSearched(true); setNewOrderStatus(6) }}
            style={{
              backgroundColor: newOrderStatus === 6 ? "#757575" : "white",
              color: newOrderStatus === 6 ? "white" : "black",
            }}
          >
            Saved For Later
          </Button>
          <Button
            onClick={() => { setHasSearched(true); setNewOrderStatus(7) }}
            style={{
              backgroundColor: newOrderStatus === 7 ? "#f52727" : "#ffffff",
              color: newOrderStatus === 7 ? "white" : "#000000",
            }}
          >
            Deleted
          </Button>
        </GridToolbarContainer>

      </>
    );
  }

  const onFilterChange = async (filterModel) => {
    try {
      setLoading(true);
      if (filterModel) {
        const response = await window.Platform.database.filterOrder({ filterField: filterModel.field, filterValue: filterModel.value, pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
      }
      else {
        const response = await window.Platform.database.filterOrder({ filterField: "date", pageNumber: paginationModel1.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
      }
      setLoading(false);
    }
    catch (err) {
      console.error(err)
      setLoading(false);
      window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
    }
  };
  const onFilterChange1 = async (filterModel) => {
    try {
      setLoading(true);
      if (filterModel) {
        const response = await window.Platform.database.filterOrderDistributor({ filterField: filterModel.field, filterValue: filterModel.value, pageNumber: paginationModel1.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
      }
      else {
        const response = await window.Platform.database.filterOrderDistributor({ filterField: "date", pageNumber: paginationModel1.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
      }
      setLoading(false);
    }
    catch (err) {
      console.error(err)
      setLoading(false);
      window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
    }
  };

  const renderContent = () => {

    if (selectedTab === 0) {
      return (<>
        <div className="d-flex justify-content-between align-items-center py-2 px-3">
          <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
            <Button
              onClick={() => { setOrderProcess("new"); }}
              sx={{
                width: 150,
                fontSize: "13px",
                backgroundColor: orderProcess === "new" ? "#1976d2" : "#e0e0e0",
                color: orderProcess === "new" ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor: orderProcess === "new" ? "#1565c0" : "#d5d5d5",
                },
              }}
            >
              Created
            </Button>
            <Button
              onClick={() => { setOrderProcess("upload"); }}
              sx={{
                width: 150,
                backgroundColor: orderProcess === "upload" ? "#1976d2" : "#e0e0e0",
                color: orderProcess === "upload" ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor: orderProcess === "upload" ? "#1565c0" : "#d5d5d5",
                },
              }}
            >
              Uploaded
            </Button>
            {(userData?.role.toLowerCase().includes('admin')) && (propType != "Specimen" && (newOrderStatus == 0)) && <Box style={{ display: "flex", gap: 4, alignItems: "center" }}>
              <Button
                onClick={() => { setShowOrderCheck(!showOrderCheck); }}
                sx={{ width: 200 }}
                color="info"
                variant="contained"
              >
                Batch Approval
              </Button>
              {
                showOrderCheck && <>
                  <Button onClick={() => { approveAllOrders(); }}
                    className="ml-1"
                    sx={{ width: 120 }}
                    color="success"
                    variant="contained"
                  >
                    Approve
                  </Button>
                  <Button onClick={() => { rejectAllOrders(); }}
                    className="ml-1"
                    sx={{ width: 120 }}
                    color="error"
                    variant="contained"
                  >
                    Reject
                  </Button>
                </>
              }
            </Box>}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
            <Select
              value={paginationModel.pageSize}
              variant="outlined"
              size="small"
              onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
              sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
            >
              {[10, 20, 30, 50, 100].map((role) => (
                <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
              ))}
            </Select>
          </Box>
        </div>
        <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={accessChanges}
            columns={getEmployeeColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600", '& .duplicate-row': { backgroundColor: '#ff00275c !important' }, '& .duplicate-row:hover': { backgroundColor: '#ff00275c !important' }, '& .duplicate-row.Mui-hovered': { backgroundColor: '#ff00275c !important' } }}
            getRowClassName={(params) => params?.row?.isDuplicate == '1' ? 'duplicate-row' : ''}
            disableSelectionOnClick
            disableRowSelectionOnClick
            rowHeight={60}
            disableDensitySelector
            pageSizeOptions={[10]}
            onFilterModelChange={(val) => {
              if (val?.items[0]?.value?.length > 0) {
                onFilterChange(val.items[0])
              }
              else if (!val.items[0]?.value && startDate && endDate) {
                onFilterChange()
              }
              else {
                fetchOrder()
              }
            }
            }
            filterMode="server"
            rowCount={rowCount}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </>
      );
    }
    else if (selectedTab === 1) {
      return (<>
        <div className="d-flex justify-content-between align-items-center py-2 px-3">
          <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
            <Button
              onClick={() => { setOrderProcess("new"); }}
              sx={{
                width: 150,
                backgroundColor: orderProcess === "new" ? "#1976d2" : "#e0e0e0",
                color: orderProcess === "new" ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor: orderProcess === "new" ? "#1565c0" : "#d5d5d5",
                },
              }}
            >
              Created
            </Button>
            <Button
              onClick={() => { setOrderProcess("upload"); }}
              sx={{
                width: 150,
                backgroundColor: orderProcess === "upload" ? "#1976d2" : "#e0e0e0",
                color: orderProcess === "upload" ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor: orderProcess === "upload" ? "#1565c0" : "#d5d5d5",
                },
              }}
            >
              Uploaded
            </Button>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
            <Select
              value={paginationModel1.pageSize}
              variant="outlined"
              size="small"
              onChange={(e) => { setHasSearched(true); setPaginationModel1({ ...paginationModel1, pageSize: e.target.value }) }}
              sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
            >
              {[10, 20, 30, 50, 100].map((role) => (
                <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
              ))}
            </Select>
          </Box>
        </div>

        <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={accessChanges}
            columns={getEmployeeColumns()}
            sx={{ '& .duplicate-row': { backgroundColor: '#ff00275c !important' }, '& .duplicate-row:hover': { backgroundColor: '#ff00275c !important' }, '& .duplicate-row.Mui-hovered': { backgroundColor: '#ff00275c !important' } }}
            getRowClassName={(params) => params?.row?.isDuplicate == '1' ? 'duplicate-row' : ''}
            disableSelectionOnClick
            disableRowSelectionOnClick
            rowHeight={60}
            pageSizeOptions={[10]}
            disableDensitySelector
            onFilterModelChange={(val) => {
              if (val?.items[0]?.value?.length > 0) {
                onFilterChange1(val.items[0])
              }
              else if (!val.items[0]?.value && startDate && endDate) {
                onFilterChange1()
              }
              else {
                fetchOrder1()
              }
            }
            }
            filterMode="server"
            rowCount={rowCount}
            paginationModel={paginationModel1}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel1}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </>
      );
    }
  };

  const formatDate = async (data) => {
    setEndDate(null)
    const datePickerResponse = new Date(data.$d);
    const year = datePickerResponse.getFullYear();
    const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
    const day = String(datePickerResponse.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate)
  }
  const onClose = async () => {
    try {
      setAddModal(false)
      setEditMode(false)
      setEditModalData(false)
    }
    catch (error) {
      setLoading(false)
    }
  }
  const exportOrders = async () => {
    setLoading(true);
    try {
      let data = {
        filter: search,
        fromDate: fromDate != '' ? fromDate : filteredDate?.startDate,
        toDate: toDate != '' ? toDate : filteredDate?.endDate,
        series: selectedSeries,
        rsm: rsm,
        startDeliveryDate: startDeliveryDate,
        endDeliveryDate: endDeliveryDate,
        distributorId: distributor,
        stockistId: stockist,
        asm: userData?.role === 'asm' ? userData?.id : asm,
        rsm: userData?.role === 'rsm' ? userData?.id : rsm,
        approvalStatus: newOrderStatus,
        order_type: propType,
        orderProcess: orderProcess
      }

      let result = await window.Platform.database.exportData("/order/exportOrders",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "schoolOrders.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const exportOrders1 = async () => {
    setLoading(true);
    try {
      let data = {
        filter: search,
        orderStatus: 1,
        fromDate: fromDate != '' ? fromDate : filteredDate?.startDate,
        toDate: toDate != '' ? toDate : filteredDate?.endDate,
        series: selectedSeries,
        order_type: propType,
        orderProcess: orderProcess,
        asm: userData?.role === 'asm' ? userData?.id : asm,
        rsm: userData?.role === 'rsm' ? userData?.id : rsm,
        ownerId: rm,
        approvalStatus: newOrderStatus
      }
      let result = await window.Platform.database.exportData("/order/exportOrders",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "distributorOrders.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }
  const clearFilters = async () => {
    setStartDeliveryDate("");
    setEndDeliveryDate("");
    setStockist("");
    setDistributor("");
    setShowOrderCheck(false);
    setSelecetAll("0");
    setSelectedOrders([]);
    setHasSearched(false);
    setLoading(true);
    setRm("")
    setAsm("")
    setRsm("")
    setSearch("")
    setFromDate("")
    setToDate("")
    setSelectedRole("")
    setSelectedSeries("")
    setOrderProcess("new");
    setNewOrderStatus(0);
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
    setPaginationModel1((prev) => ({ ...prev, pageSize: 20 }))
    setIsDateRangeDisabled(false);
    setAccessChanges([]);
    setRowCount(0);
    setLoading(false);
  }

  const findOrdersByDate = async () => {
    try {
      setLoading(true);
      let data1 = {
        pageNumber: paginationModel.page,
        approvalStatus: newOrderStatus
      }
      let results;
      results = await window.Platform.database.fetchOrder(data1, selectedRole, selectedSeries, search, fromDate, toDate);
      console.log("results=======", results);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setRowCount(results?.data1)
      setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const handleSelectAll = (e) => {
    setSelecetAll("1")
    if (e.target.checked) {
      const allSchoolIds = newRows.map((row) => row.orderId);
      setSelectedOrders(allSchoolIds);
    } else {
      setSelecetAll("0")
      setSelectedOrders([]);
    }
  };

  return (
    <>
      <StaffEditorPageContainer>
        <HeaderContainer>
          {loading && <OpaqueLoading />}
          <Box sx={{ mt: 1, width: "100%" }}>

            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              <div className="container-fluid" style={{ width: "100%" }}>

                <div className="row">
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Type To Search"
                        label="Search By SO ID "
                        value={search}
                        onChange={(e) => setSearch(e.target.value)} // Proper event handler
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search color="action" sx={{ color: "black" }} />
                            </InputAdornment>
                          ),
                          style: { color: "black", fontSize: "16px", fontWeight: "500" }
                        }}
                        InputLabelProps={{
                          style: { color: "black", fontSize: "16px" }, // Label color
                        }}
                      />
                    </FormControl>
                  </div>
                  {userData?.role.includes('admin') && <div className="col-md-2">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                      <Select
                        label="Select HO"
                        value={rsm}
                        size="small"
                        onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }}
                        sx={{ fontSize: 14, fontWeight: "500" }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {rsms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  {userData?.role != 'asm' && <div className="col-md-2">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                      <Select
                        label="Selecct ARM"
                        value={asm}
                        variant="outlined"
                        size="small"
                        onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }}
                        sx={{ fontSize: 14, fontWeight: "500" }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {asms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  <div className="col-md-2">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                      <Select
                        fullWidth
                        label="Select RM"
                        value={rm}
                        size="small"
                        onChange={(e) => { setRm(e.target.value) }}
                        sx={{ fontSize: 14, fontWeight: "500" }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {rms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Series:</InputLabel>
                      <Select
                        label="Select Series"
                        fullWidth
                        value={selectedSeries}
                        size="small"
                        onChange={(e) => { setSelectedSeries(e.target.value) }}
                        sx={{ fontSize: 14, fontWeight: "500" }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {series.map((role) => (
                          <MenuItem key={role} value={role.seriesTableId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.seriesName}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={fromDate}
                        disabled={isDateRangeDisabled}
                        onChange={(e) => {
                          setFromDate(e.target.value)
                        }}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={toDate}
                        disabled={isDateRangeDisabled}
                        onChange={(e) => {
                          setToDate(e.target.value)
                        }}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                  <div className="col-md-2">
                    <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); selectedTab == 0 ? fetchOrder() : fetchOrder1() }}>
                      Find
                    </Button>
                  </div>
                  <div className="col-md-2">
                    <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"20"} width={"18"} />} color="secondary" size="small" fullWidth sx={{ fontSize: '12px', borderRadius: '10px', width: "100%", padding: "6px 0px 6px 0px" }} onClick={() => clearFilters()}>
                      Clear Filters
                    </Button>
                  </div>
                  {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-2">
                    {selectedTab == 0 ? <Button fullWidth variant="contained" size="small" color="success" startIcon={<FileDownloadIcon />} sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { exportOrders() }}>Download</Button> : <Button fullWidth variant="contained" sx={{ fontSize: '14px', borderRadius: '10px' }} size="small" color="success" startIcon={<FileDownloadIcon />} onClick={() => { exportOrders1() }}>Download</Button>}
                  </div>}
                </div>
                {selectedTab == 0 && propType != "Specimen" && <div className="row mt-2">
                  <div className="col-md-3">
                    <Autocomplete
                      size="small"
                      fullWidth
                      options={stockists || []}
                      getOptionLabel={(option) =>
                        `${option.StockistName} - ${option.stockistID}`
                      }
                      value={
                        stockists?.find(s => s.stockistID === stockist) || null
                      }
                      onChange={(event, newValue) => {
                        setStockist(newValue ? newValue.stockistID : "");
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.stockistID === value.stockistID
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Stockist"
                          sx={{
                            "& label": { fontSize: "14px", fontWeight: "500", color: "black" },
                            "& input": { fontSize: "14px", fontWeight: "500" }
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-3">
                    <Autocomplete
                      size="small"
                      fullWidth
                      options={distributors || []}
                      getOptionLabel={(option) =>
                        `${option.DistributorName} - ${option.distributorID}`
                      }
                      value={
                        distributors?.find(d => d.distributorID === distributor) || null
                      }
                      onChange={(event, newValue) => {
                        setDistributor(newValue ? newValue.distributorID : "");
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.distributorID === value.distributorID
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Distributor"
                          sx={{
                            "& label": { fontSize: "14px", fontWeight: "500", color: "black" },
                            "& input": { fontSize: "14px", fontWeight: "500" }
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <TextField label=" Delivery Date: Start" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control"
                        value={startDeliveryDate}
                        onChange={(e) => { setStartDeliveryDate(e.target.value); }}
                        InputLabelProps={{ shrink: true, style: { color: "black", fontSize: "13px", fontWeight: 500 } }}
                        inputProps={{ style: { color: "black", fontSize: "13px", fontWeight: 500 } }} />
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <TextField label=" Delivery Date: End" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control"
                        value={endDeliveryDate}
                        onChange={(e) => { setEndDeliveryDate(e.target.value); }}
                        InputLabelProps={{ shrink: true, style: { color: "black", fontSize: "13px", fontWeight: 500 } }}
                        inputProps={{ style: { color: "black", fontSize: "13px", fontWeight: 500 } }} />
                    </FormControl>
                  </div>
                </div>}
              </div>
            </Paper>
            {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" && <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                startIcon={<FileDownloadIcon />}
                variant="contained"
                color="primary"
                onClick={() => handleDownloadAllImagesZip(accessChanges)}
              >
                Download All Attachments
              </Button>
              <Button variant="contained" color="primary"
                onClick={() => { setAddModal(true); setEditModalData(null); setEditMode(false); }} sx={{ mr: 1, borderRadius: '10px' }}>
                <Add sx={{ mr: 1 }} />
                Add New Order
              </Button>
            </Box>}
          </Box>
        </HeaderContainer>
        <TableContainer>
          <TabsContainer>
            <StyledTabs
              variant="fullWidth"
              value={selectedTab}
              onChange={(event, value) => handleTabChange(value)}
              indicatorColor="none"
              textColor="primary"
            >
              <Tab label="School Orders" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: selectedTab == 0 ? "#fff" : "#e6e3e3de " }} />
              <Tab label="Distributor Orders" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: selectedTab == 1 ? "#fff" : "#e6e3e3de " }} />
            </StyledTabs>
            {renderContent()}
          </TabsContainer>
        </TableContainer>
      </StaffEditorPageContainer>
      {
        modal &&
        <OrderLineItemModal
          onCancel={() => setModal(null)}
          loading={loading}
          data={modalData}
          props={accessChanges}
          typeProp={propType}
        />
      }
      {
        addModal && <AddOrderModal onClose1={onClose} onClose={() => setAddModal(false)} partyS={selectedTab == 0 ? 'school' : 'distributor'}
          fetchData={() => selectedTab == 0 ? fetchOrder() : fetchOrder1()}
          status={true} editMode={editMode} dataProp={editModalData} propType = {propType}/>
      }
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Reject Order</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Remark"
            type="text"
            fullWidth
            variant="outlined"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)} fullWidth>
        <DialogTitle>Delete Order</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Remark"
            type="text"
            fullWidth
            variant="outlined"
            value={deleteRemark}
            onChange={(e) => setDeleteRemark(e.target.value)}
            multiline
            rows={3}
            placeholder="Enter reason for deletion"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenDeleteDialog(false); setDeleteRemark(""); setDeleteOrderData(null); }} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Modal open={convertModalOpen} onClose={() => { setSelectedImages([]); setConvertData(null); setConvertModalOpen(false);}}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" mb={2}>
            <b>Convert to Order</b>
          </Typography>
          <Typography mb={2}>
            <span style={{fontSize:"13px", color:"#000", fontWeight:"500"}}>you are converting this entry into an Order. Please confirm this action is intentional.</span>
          </Typography>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={(e) => setSelectedImages(Array.from(e.target.files))}
            style={{ marginBottom: 16 }}
          />
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={() => { setConvertModalOpen(false); setSelectedImages([]); setConvertData(null); }} variant="outlined">
              Cancel
            </Button>
            <Button onClick={() => handleConfirmConvert()} variant="contained" color="primary">
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={chooseAttachmentModal} onClose={() => { setChooseAttachmentModal(false); setConvertData(null); }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" mb={2}>
            Convert to Order
          </Typography>
          <Typography mb={2}>
            Do you want to convert with or without attachment?
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={() => { setChooseAttachmentModal(false); setConvertModalOpen(true); }} variant="contained" color="primary">
              With Attachment
            </Button>
            <Button onClick={handleConvertWithoutAttachment} variant="outlined">
              Without Attachment
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
